// extracted by mini-css-extract-plugin
module.exports = {"container":"content_container__WkNNh","header":"content_header__R5wwG","fitDescription":"content_fitDescription__tY7xn"};